import React from 'react';
import { motion } from 'framer-motion';
export function TechPartners() {
  const partners = ['SentientLogics AI powered by Prisma AI', 'Microsoft Azure', 'AWS', 'Google Cloud', 'OpenAI', 'LangChain', 'Hugging Face'];
  // Duplicate for seamless infinite scroll
  const marqueeItems = [...partners, ...partners, ...partners];
  return <section className="py-16 bg-[#1a1718] border-y border-white/5 overflow-hidden" data-id="element-182">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10 text-center" data-id="element-183">
        <h2 className="text-brand-primary font-semibold uppercase tracking-wider text-sm mb-2" data-id="element-184">
          Our Technology Partners
        </h2>
        <p className="text-gray-400" data-id="element-185">
          Powered by world-class AI infrastructure
        </p>
      </div>

      <div className="relative w-full flex overflow-hidden" data-id="element-186">
        {/* Gradient Masks for smooth fade on edges */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#1a1718] to-transparent z-10 pointer-events-none" data-id="element-187"></div>
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#1a1718] to-transparent z-10 pointer-events-none" data-id="element-188"></div>

        <motion.div className="flex whitespace-nowrap gap-8 py-4 px-4" animate={{
        x: ['0%', '-33.33%']
      }} transition={{
        repeat: Infinity,
        ease: 'linear',
        duration: 25
      }} data-id="element-189">
          {marqueeItems.map((partner, index) => <div key={index} className="glass-card px-8 py-4 rounded-full text-gray-300 font-medium text-lg hover:text-white hover:border-brand-primary/50 hover:glow-blue transition-all duration-300 cursor-default flex-shrink-0" data-id="element-190">
              {partner}
            </div>)}
        </motion.div>
      </div>
    </section>;
}